var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-heading inner"},[(_vm.pageTitle)?_c('h1',[_vm._v(_vm._s(_vm.pageTitle))]):_vm._e(),_vm._v(" "),(_vm.pageText)?_c('p',[_vm._v(_vm._s(_vm.pageText))]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e24c8c7","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/modules/03_page_heading/template.html
// module id = null
// module chunks = 